/**
 * Concatenates the page title and brand with a '|' separator, filtering out any falsy values.
 * @param $t - The translation function or object.
 * @param pageTitle - The title of the current page.
 * @returns The concatenated page title.
 * @category Utils
 */export default ($t, pageTitle) => [pageTitle, $t.brand].filter(Boolean).join(' | ')
